import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild,
} from "@angular/core";
import { GUID } from "@barthauer/abc/core";
import {
  DataService as CoreDataService,
  PersistMode,
  QueryColumn,
} from "@barthauer/abc/core/data";
import {
  Address,
  DefaultIcons,
  MailAndWebAddress,
  PhoneNumber,
} from "@barthauer/custom/xmt-models";
import {
  DxButtonModule,
  DxDataGridModule,
  DxFormModule,
  DxPopupModule,
} from "devextreme-angular";

import {
  AbcDropDownBoxComponent,
  AbcPopupComponent,
  AbcSpeedDialActionComponent,
  AbcTextBoxComponent,
  _AbcButtonComponent,
  _AbcContextMenuComponent,
  _AbcFormComponent,
  _AbcGridComponent,
  _AbcScrollViewComponent,
} from "@barthauer/abc/ui-components";
import {
  DxContextMenuModule,
  DxDateBoxModule,
  DxSpeedDialActionModule,
  DxTagBoxModule,
  DxTileViewModule,
} from "devextreme-angular";
import { DxiItemModule } from "devextreme-angular/ui/nested";
import { locale } from "devextreme/localization";
import { Column } from "devextreme/ui/data_grid";
import { FlexLayoutModule } from "ngx-flexible-layout";
import { forkJoin, Observable, of, Subscription } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import {
  NotificationMessage,
  ActionType,
  ToastType,
} from "../../models/enumeration-list.model";
import { AppService } from "../../services/app.service";
import { DataService, ObjectKeys } from "../../services/data.service";
import { LanguageService } from "../../services/language.service";
import { NotificationService } from "../../services/notification.service";
import { ObjectTypeNames } from "../../shared/companies/companies.service";
import { FavoritesService } from "../../shared/favorite/favorites.service";
import { SharedModule } from "../../shared/shared.module";
import { AddressViewModel } from "../../view-models/address.view-model";
import { CompanyService } from "./company.service";
import { CheckPermissionDirective } from "../../directives/check-permession-directive";
import { ScreenService } from "../../services/screen.service";
@Component({
  selector: "ubt-geods-companies-list",
  templateUrl: "./companies-list.component.html",
  styleUrls: ["./companies-list.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FlexLayoutModule,
    DxPopupModule,
    DxTileViewModule,
    DxContextMenuModule,
    DxSpeedDialActionModule,
    DxTagBoxModule,
    SharedModule,
    DxButtonModule,
    DxiItemModule,
    DxDateBoxModule,
    DxFormModule,
    _AbcFormComponent,
    DxDataGridModule,
    _AbcGridComponent,
    AbcPopupComponent,
    AbcSpeedDialActionComponent,
    _AbcScrollViewComponent,
    _AbcButtonComponent,
    _AbcContextMenuComponent,
    CheckPermissionDirective,
    AbcDropDownBoxComponent,
  ],
  providers: [CompanyService
  ],
})
export class CompaniesListComponent implements OnInit, AfterViewInit {
  @ViewChild(_AbcScrollViewComponent, { static: true })
  scrollView: _AbcScrollViewComponent;
  @ViewChild("formCompanyPopup") formCompanyPopup: AbcPopupComponent;
  @ViewChild("deleteCompanyPopup") deleteCompanyPopup: AbcPopupComponent;
  @ViewChild("form") form: _AbcFormComponent;
  @ViewChild("companyGrid") companyGrid: _AbcGridComponent;
  @ViewChild("emailTextBox") emailTextBox: AbcTextBoxComponent;
  @ViewChild("phoneTextBox") phoneTextBox: AbcTextBoxComponent;
  @ViewChild("faxTextBox") faxTextBox: AbcTextBoxComponent;
  @ViewChild("contextMenu") contextMenu: _AbcContextMenuComponent;

  public companies: AddressViewModel[] = [];
  public company: Address = new Address(null);
  public phoneNumber: PhoneNumber = new PhoneNumber(null);
  public email: MailAndWebAddress = new MailAndWebAddress(null);
  public columns: QueryColumn[] = [];
  public cachedStatus = [];
  private isGridInitialized = false;
  private pendingStatusDataSource = [];
  public cachedCompaniesTitles: string[] = [];
  public cancelButtonOptions = {
    text: this.dataService.res("Ubt-Button-Cancel"),
    onClick: () => this.closePopup(),
  };
  public columnsHeader: Column[] = [
    {
      caption: this.dataService.res("Ubt-Company-Column-Name"),
      dataField: "name",
      visibleIndex: 0,
    },
    {
      caption: this.dataService.res("Ubt-Company-Column-Organization"),
      dataField: "businessLine",
      visibleIndex: 1,
      lookup: {
        dataSource: [],
        displayExpr: "Description",
        valueExpr: "Value",
      },
    },
    {
      caption: this.dataService.res("Ubt-Company-Column-Match-Code"),
      dataField: "matchCode",
      visibleIndex: 2,
    },
    {
      caption: this.dataService.res("Ubt-Company-Column-Status"),
      dataField: "status",
      visibleIndex: 3,
      lookup: {
        dataSource: this.cachedStatus,
        displayExpr: "Description",
        valueExpr: "Value",
      },
    },

    {
      caption: this.dataService.res("Ubt-Company-Column-Street"),
      dataField: "street",
      visibleIndex: 4,
    },
    {
      caption: this.dataService.res("Ubt-Company-Column-City"),
      dataField: "city",
      visibleIndex: 5,
    },
    {
      caption: this.dataService.res("Ubt-Company-Column-Zip"),
      dataField: "zip",
      visibleIndex: 6,
    },
    {
      caption: this.dataService.res("Ubt-Company-Column-Phone"),
      dataField: "fullNumber",
      visibleIndex: 7,
      visible: false,
    },
    {
      caption: this.dataService.res("Ubt-Company-Column-Email"),
      dataField: "email",
      visibleIndex: 8,
      visible: false,
    },
    {
      caption: this.dataService.res("Ubt-Company-Column-Customer-Number"),
      dataField: "customerNumber",
      visibleIndex: 9,
      visible: false,
    },
    {
      type: "buttons",
      caption: "",
      alignment: "left",
      dataField: "",
      visibleIndex: 10,
      minWidth: 50,
      width: "50px",
    },
  ];

  public noDataText = this.dataService.res("Ubt-No-Data-text");
  private subscriptions: Subscription[] = [];
  private companyId: string;
  public contextMenuItems: any[] = [
    {
      text: this.dataService.res("Ubt-Company-Edit-Company"),
      onClick: (event) => {
        this.openCompanyDetail(event);
      },
    },

    {
      text: this.dataService.res("Ubt-Company-Delete-Company"),
      onClick: (event) => {
        this.openDeleteCompanyDialog(event);
      },
    },
  ];

  public titlegrid = this.dataService.res("Ubt-SubProject-Create-Company");
  protected ActionType = ActionType;
  private currentLanguage: string | null;
  constructor(
    public dataService: DataService,
    public appService: AppService,
    private coreDataService: CoreDataService,
    public favoritesService: FavoritesService,
    public companyService: CompanyService,
    private cdr: ChangeDetectorRef,
    private notificationService: NotificationService,
    private languageService: LanguageService,
    private readonly screenService: ScreenService,

  ) {

  }
  ngOnInit(): void {
    this.appService.showLoader(true);
    this.prepareFormDataSource()
    this.phoneNumber.Type = 0;
  }
  ngAfterViewInit(): void {

    this.subscriptions.push(
      this.screenService.screen$.subscribe(({ screenSize, isMenuOpened }) => {
        this.screenService.setGridColumnsWidth(
          this.columnsHeader,
          this.companyGrid,
          screenSize,
          isMenuOpened,
          this.getColumnWidth,
        );
      }),
    );


  }

  public onGridInitialized(e): void {
    this.isGridInitialized = true;
    if (this.pendingStatusDataSource !== null) {
      e.component.columnOption(
        "status",
        "lookup.dataSource",
        this.cachedStatus,
      );
    }
  }
  private getColumnWidth = (
    key: string,
    isMenuOpened: boolean,
    largeScreenAddition: number = 0,
  ): string => {
    switch (key) {
      case "name":
      case "businessLine":
      case "street":
        return isMenuOpened
          ? `${(200 + largeScreenAddition).toString()}px`
          : `${(240 + largeScreenAddition).toString()}px`;
      case "matchCode":
      case "status":
      case "city":
      case "zip":
        return isMenuOpened
          ? `${(100 + largeScreenAddition).toString()}px`
          : `${(140 + largeScreenAddition).toString()}px`;
      default:
        return "50px";
    }
  };
  private prepareFormDataSource(): void {
    forkJoin([
      this.dataService.loadListDataSource("Address", "Status"),
    ]).subscribe((data: any) => {
      this.cachedStatus.length = 0;
      if (data[0].Data) {
        this.cachedStatus.push(
          ...data[0].Data.map((s) => ({ ...s, Value: s.Value?.toString() })),
        );
      }

      const statusCol = this.columnsHeader.find((c) => c.dataField === "status");
      if (statusCol?.lookup) {
        statusCol.lookup.dataSource = this.cachedStatus;
      }


      if (this.isGridInitialized && this.companyGrid?.instance) {
        this.companyGrid.instance.columnOption(
          "status",
          "lookup.dataSource",
          this.cachedStatus,
        );
      }
      else {

        this.pendingStatusDataSource = this.cachedStatus;
      }

      this.getCompaniesData();
      this.appService.showLoader(false);
      this.cdr.markForCheck();
    });
  }
  updatedTranslation(value: string) {
    if (value === "de" || value == null) {
      locale("de");
    } else {
      locale("en");
    }
    let test = this.dataService.res("Ubt-SubProject-Create-Company");
    this.titlegrid = test;

    const captionsDictionary = {
      0: "Ubt-Company-Column-Name",
      1: "Ubt-Company-Column-Organization",
      2: "Ubt-Company-Column-Match-Code",
      3: "Ubt-Company-Column-Status",
      4: "Ubt-Company-Column-Street",
      5: "Ubt-Company-Column-City",
      6: "Ubt-Company-Column-Zip",
      7: "Ubt-Company-Column-Phone",
      8: "Ubt-Company-Column-Email",
      9: "Ubt-Company-Column-Customer-Number",
    };

    const documentHeader = this.columnsHeader.map((column) => {
      const translationKey = captionsDictionary[column.visibleIndex];
      if (translationKey) {
        const translatedCaption = this.dataService.res(translationKey);
        return {
          ...column,
          caption: translatedCaption,
        };
      }
      return column;
    });

    this.columnsHeader = documentHeader;
    this.cdr.detectChanges();
  }

  public onCellPrepared(e) {
    if (e.rowType === "data" && e.column.type === "buttons") {
      e.cellElement.style.cursor = "pointer";
      e.cellElement.innerHTML = DefaultIcons.CONTEXTMENU;
    }
    if (e.rowType === "data" && e.column.dataField === "status") {
      const statusValue = e.data.status;
      const statusObj = this.cachedStatus.find((s) => s.Value == statusValue);
      if (statusObj) {
        e.cellElement.innerText = statusObj.Description;
      }
    }
  }

  public onCellClick(e) {
    if (e.column?.command === "adaptive") {
      e.event?.stopPropagation();
      return;
    }

    if (e.rowType === "data") {
      this.company = e.data?.address;

      if (e.column.type === "buttons") {
        this.getCompanyFields(e);
        this.companyService.isUpdating = true;
        if (this.company.Phone) this.formatNumber("Phone");
        if (this.company.Fax) this.formatNumber("Fax");

        e.cellElement.className = "context-menu-icon" + e.rowIndex;
        e.cellElement.innerHTML = this.contextMenu.visible
          ? DefaultIcons.CLOSE
          : DefaultIcons.CONTEXTMENU;

        this.contextMenu.target = ".context-menu-icon" + e.rowIndex;

        this.contextMenuItems[0].visible = this.dataService.hasPermission(
          "Companies",
          ActionType.UPDATE,
        );
        this.contextMenuItems[1].visible = this.dataService.hasPermission(
          "Companies",
          ActionType.DELETE,
        );
        this.contextMenu.instance.show();
      }
    }
  }

  public getCompaniesData() {
    let companyTitles = [];
    this.subscriptions.push(
      this.coreDataService
        .executeReadObjectsQuery(this.companyService.prepareCompanyColumns())
        .subscribe((companies: any) => {
          companies.forEach((company) => {
            const companyData = new AddressViewModel(company);
            if (
              companyData.businessLine !== null &&
              companyTitles
                .map((a) => a.Value)
                .indexOf(companyData.businessLine) === -1
            ) {
              companyTitles.push({
                Value: companyData.businessLine,
                Description: companyData.businessLine,
              });
            }
            this.companies.push(companyData);
          });
          if (this.companyGrid?.instance) {
            this.companyGrid.instance.columnOption(
              "businessLine",
              "lookup.dataSource",
              companyTitles,
            );
          }
          const businessLineCol = this.columnsHeader.find(
            (c) => c.dataField === "businessLine",
          );
          if (businessLineCol && businessLineCol.lookup) {
            businessLineCol.lookup.dataSource = companyTitles;
          }

          this.cdr.markForCheck();
        }),
    );
  }
  public validTextBoxStatus(): boolean {
    if (this.emailTextBox.validationStatus !== "invalid") {
      return true;
    } else return false;
  }
  private formatNumber(field: string) {
    this.company[field] = this.company[field].replace(" (", "");
    this.company[field] = this.company[field].replace(") ", "");
  }

  public openCompanyDialog(): void {
    this.company = new Address(null);
    this.companyService.isUpdating = false;
    if (this.company.Phone) this.formatNumber("Phone");
    if (this.company.Fax) this.formatNumber("Fax");
    this.cancelButtonOptions.text = this.dataService.res("ubt-Button-Cancel");
    this.formCompanyPopup.title = this.dataService.res(
      "Ubt-Company-Title-Create-Company",
    );
    this.formCompanyPopup.instance.show();
  }

  public onCreateCompany(event) {
    event.preventDefault();
    if (this.validTextBoxStatus()) {
      this.companyService
        .persistCompany(this.company as any)
        .pipe(
          switchMap((company) => {
            this.company.Id = company.Id;
            this.companyId = company.Id;
            return this.createMailFaxPhone(company.Id);
          }),
        )
        .subscribe(
          (data) => {
            if (this.companyService.isUpdating === false) {
              this.getCompanyById(this.companyId);
            }
            const company = new AddressViewModel(this.company);
            company.email = this.email.Value;
            this.closePopup();
            this.companyGrid.instance.refresh();
            this.cdr.markForCheck();
          },
          (error) => {
            console.error(error);
            this.notificationService.callNotification({
              message: NotificationMessage.Error,
              type: ToastType.ERROR,
            });
          },
          () => {
            this.appService.showLoader(false);
            this.companyGrid.instance.refresh();
            this.cdr.markForCheck();
          },
        );
    }
  }

  private getCompanyById(companyId: string) {
    this.appService.showLoader(true);
    const opath = "Id=" + "'" + companyId + "'";
    this.subscriptions.push(
      this.coreDataService
        .executeReadObjectsQuery(
          this.companyService.prepareCompanyColumns(opath),
        )
        .subscribe(
          (company: any) => {
            if (Array.isArray(company) && company.length > 0) {
              this.company = company[0];
              this.companies.push(new AddressViewModel(this.company));
              const dataSource =
                (this.companyGrid.instance.columnOption(
                  "businessLine",
                  "lookup.dataSource",
                ) as Array<{
                  Value;
                  Description;
                }>) || [];
              dataSource.push({
                Value: this.company.BusinessLine,
                Description: this.company.BusinessLine,
              });
              this.companyGrid.instance.columnOption(
                "businessLine",
                "lookup.dataSource",
                dataSource,
              );
              const businessLineCol = this.columnsHeader.find(
                (c) => c.dataField === "businessLine",
              );
              if (businessLineCol && businessLineCol.lookup) {
                businessLineCol.lookup.dataSource = dataSource;
              }
              this.companyGrid.instance.refresh();
              this.cdr.markForCheck();
            } else {
              this.companies = [];
              this.notificationService.callNotification({
                message: NotificationMessage.Empty,
                type: ToastType.INFO,
              });
            }
          },
          (error) => {
            this.appService.showLoader(false);
            console.error(error);
            this.cdr.markForCheck();
          },
          () => {
            this.cdr.markForCheck();
          },
        ),
    );
  }

  private createMailFaxPhone(companyId: string): Observable<any> {
    return forkJoin([
      this.createUpdatePhoneNumber(companyId),
      this.createUpdateMail(companyId),
    ]);
  }
  private addCompaniesValidation = {
    validatePhoneNumber(phoneNumber: PhoneNumber): boolean {
      return (
        !!phoneNumber.CountryCode &&
        !!phoneNumber.LocalAreaCode &&
        !!phoneNumber.Mediation &&
        !!phoneNumber.Number
      );
    },
    validateEmail(email: string): boolean {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return emailRegex.test(email);
    },
  };

  private createUpdatePhoneNumber(companyId: string): Observable<any> {
    if (this.addCompaniesValidation.validatePhoneNumber(this.phoneNumber)) {
      return this.companyService.persistPhoneNumber(
        this.phoneNumber,
        companyId,
        this.phoneNumber.Id,
      );
    } else {
      return of([]);
    }
  }

  private createUpdateMail(companyId: string): Observable<any> {
    if (this.addCompaniesValidation.validateEmail(this.email.Value)) {
      return this.companyService.persistMailAddress(
        this.email,
        companyId,
        this.email.Id,
      );
    } else {
      return of([]);
    }
  }
  public companiesUpdateState(event, state: string, favoriteData?): void {
    let selectedIndex = this.companies.findIndex(
      (company) => company.id === event.row?.data.Id,
    );
    if (state === "add") {
      const clonedItem = {
        ...event.row?.data,
        IsFavorite: 1,
        BoxDetailId: favoriteData.Id,
      };
      this.companies[selectedIndex] = clonedItem;
    } else {
      const clonedItem = { ...event.row?.data, IsFavorite: 0 };
      this.companies[selectedIndex] = clonedItem;
    }
  }

  public openCompanyDetail(event): void {
    this.cancelButtonOptions.text = this.dataService.res("ubt-Button-Cancel");
    this.formCompanyPopup.title = this.dataService.res(
      "Ubt-Company-Title-Edit-Company",
    );
    this.formCompanyPopup.instance.show();
  }

  private getCompanyFields(event): void {
    this.company = event.row?.data["address"];
    if (this.company["MailAddress"]) {
      this.email = new MailAndWebAddress(this.company["MailAddress"][0] as any);
    }
    if (this.company["PhoneNumbers"]) {
      this.phoneNumber = this.company["PhoneNumbers"][0];
    }
  }

  public emptyData(): void {
    this.company = new Address(null);
    this.phoneNumber = new PhoneNumber(null);
    this.phoneNumber.Type = 0;
    this.email = new MailAndWebAddress(null);
    this.form.instance.resetValues();
  }

  public openDeleteCompanyDialog(event): void {
    this.deleteCompanyPopup.instance.show();
  }

  public deleteCompany(): void {
    const companyId = this.company.Id;

    this.subscriptions.push(
      this.companyService.prepareCompanyPermissions(companyId).pipe(

        map(permissions => permissions.map(p => p.Id)),


        switchMap(ids =>
          ids.length > 0
            ? this.companyService.deleteObjects(ObjectKeys.USER_ROLE_PERMISSION, ids)
            : of(null)
        ),


        switchMap(() => this.dataService.deleteObject(ObjectKeys.ADDRESS, companyId))
      ).subscribe({
        next: () => {
          const index = this.companies.findIndex(item => item.id === companyId);
          if (index !== -1) {
            this.companies.splice(index, 1);
          }

          this.deleteCompanyPopup.instance.hide();

        },
        error: (err) => {
          console.error('Failed to delete company or related permissions:', err);

        }
      })
    );
  }
  public closePopup(): void {
    this.formCompanyPopup?.instance.hide();
    this.deleteCompanyPopup?.instance.hide();
    this.emptyData();
  }

  public addFavorite(event): void {
    console.error("Not implemented yet!");
    this.favoritesService
      .persistFavoriten(
        GUID.newGUID(),
        ObjectTypeNames.Company,
        event.row?.data.Id,
        event.row?.data.name,
      )
      .subscribe((data) => {
        this.companiesUpdateState(event, "add", data);
      });
  }

  public deleteFavorite(event): void {
    this.favoritesService.deleteFavoriten(event.row?.data.BoxDetailId);
    this.companiesUpdateState(event, "delete");
  }
}
